/* eslint-disable no-console */
export function setSession(session) {
    console.log('setSession:', session);
    return {
        type: 'SET_SESSION',
        payload: session
    };
}


// WEBPACK FOOTER //
// ./src/universal/actions/action_session.js